var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrinidadAndTobago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8293 2.2207C9.03884 3.14484 7.35814 4.35617 5.8572 5.85711C4.35619 7.35812 3.14486 9.03883 2.22079 10.8293L15.0807 24.9191L29.1705 37.779C30.961 36.8548 32.6417 35.6435 34.1427 34.1427C35.6437 32.6416 36.8549 30.9609 37.7791 29.1705L24.9192 15.0806L10.8293 2.2207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1429 34.1427C34.9818 33.3037 35.7301 32.4085 36.3889 31.4695L8.53067 3.61121C7.59169 4.26988 6.69645 5.01816 5.85747 5.85714C5.01848 6.69613 4.2702 7.59136 3.61145 8.53043L31.4697 36.3885C32.4086 35.7299 33.3039 34.9817 34.1429 34.1427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85721 34.1426C12.1671 40.4525 21.6435 41.6638 29.1705 37.7789L2.22088 10.8292C-1.66388 18.3563 -0.452397 27.8327 5.85721 34.1426V34.1426Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1429 5.85716C27.833 -0.452684 18.3566 -1.66393 10.8296 2.22068L37.7792 29.1705C41.6641 21.6435 40.4528 12.167 34.1429 5.85716V5.85716Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrinidadAndTobago);
export default __webpack_public_path__ + "static/media/trinidad_and_tobago.820d817821ad4102cc8a03a1d85b6a3c.svg";
export { ForwardRef as ReactComponent };